import {
  FareInfo,
} from '@dapi/sdk';

export const fareInfo: FareInfo = {
  fareType: 'public',
  fareClass: 'NHYO6L',
  pricedPassengerTypeCodes: ['ADT'],
  travelerIds: ['ADT-1']
};
